<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div id="titre">{{crime}} locations for year {{year}}</div>
            <div id="map" leaflet (leafletMapReady)="onMapReady($event)" [leafletOptions]="options" [leafletMarkerCluster]="markerClusterData">
            </div>
        </div>
    </div>
</div>
